import api from './api'
import { langBasename } from './lang'

export type SnapshotType = 'analysis' | 'crawl' | 'tool' | 'rank'

export interface CreateSnapshotInput {
  type: SnapshotType
  title?: string
  domain?: string
  source_id?: number | string | null
  payload: any
  password?: string
  expires_in_days?: number
}

/** Vytvoří zmrazený snapshot. Vrací token a příznak, zda byl odkaz znovupoužit. */
export async function createSnapshot(input: CreateSnapshotInput): Promise<{ token: string; reused: boolean }> {
  const { data } = await api.post('/snapshots', input)
  return { token: data.token, reused: !!data.reused }
}

/**
 * Veřejná URL snapshotu — respektuje jazykový prefix (basename).
 * cs → https://host/s/{token}, en → https://host/en/s/{token}.
 */
export function snapshotUrl(token: string): string {
  const base = langBasename() // '/' nebo '/en'
  const prefix = base === '/' ? '' : base
  return `${window.location.origin}${prefix}/s/${token}`
}
